<form [formGroup]="addressForm">
    <kendo-formfield class="street">
        <kendo-label class="form-label" [for]="street" text="{{'institution.address.street' | translate}} *" [infotooltip]="'adresse.strasse'"></kendo-label>
        <kendo-textbox #street formControlName="street" showSuccessIcon="initial" showErrorIcon="initial" [appinfotext]="'adresse.strasse'" preventEmptyFormatter [maxlength]=100></kendo-textbox>
    </kendo-formfield>

    <kendo-formfield class="ortssuche">
        <kendo-label class="form-label" [for]="ortssuche" text="{{'institution.adress.postalcode_search' | translate}}" [infotooltip]="'adresse.ortssuche'"></kendo-label>
        <kendo-combobox formControlName="ortssuche" #ortssuche [data]="postleitzahlzuordnungen | async"
            [filterable]="true" (filterChange)="postleitzahlzuordnungFilterChange($event)"
            (valueChange)="postleitzahlzuordnungValueChange($event)" textField="name" valueField="id"
            placeholder="{{'institution.address.locationSearch' | translate}}" [attr.aria-label]="'institution.address.locationSearch' | translate" [appinfotext]="'adresse.ortssuche'" [valuePrimitive]="true">
            <ng-template kendoComboBoxNoDataTemplate>
                <h6 translate>
                    <span class="k-icon k-i-exclamation-circle"></span><br /><br />
                    institution.address.locationSearchInfoText
                </h6>
            </ng-template>
        </kendo-combobox>
    </kendo-formfield>

    <kendo-formfield class="postalcode">
        <kendo-label class="form-label" [for]="postalcode" text="{{'institution.address.postalcode' | translate}} *" [infotooltip]="'adresse.postleitzahl'"></kendo-label>
        <kendo-textbox #postalcode formControlName="postalcode" showSuccessIcon="initial" showErrorIcon="initial"
            [appinfotext]="'adresse.postleitzahl'" preventEmptyFormatter [maxlength]=20></kendo-textbox>
    </kendo-formfield>

    <kendo-formfield class="city">
        <kendo-label class="form-label" [for]="city" text="{{'institution.address.city' | translate}} *" [infotooltip]="'adresse.ort'"></kendo-label>
        <kendo-textbox #city formControlName="city" showSuccessIcon="initial" showErrorIcon="initial"
            [appinfotext]="'adresse.ort'" preventEmptyFormatter [maxlength]=100></kendo-textbox>
    </kendo-formfield>

    <kendo-formfield class="bundesland">
        <kendo-label class="form-label" [for]="bundesland" text="{{'institution.address.federalState' | translate}}"></kendo-label>
        <kendo-combobox formControlName="bundesland" #bundesland [data]="bundeslaenderItems"
            [valuePrimitive]="true" kendoDropDownFilter>
        </kendo-combobox>
    </kendo-formfield>
</form>